/** `/conocimiento/$slug`: la ficha y su firma (ficha.html) con el cliente del Studio. */
import { useParams, useSearch } from "@tanstack/react-router";
import { studio } from "../../api/client";
import { Ficha } from "./Ficha";

export function FichaPage() {
  const { slug } = useParams({ strict: false }) as { slug: string };
  const s = useSearch({ strict: false }) as { estado?: string; firma?: string };
  return <Ficha api={studio.biblioteca} telemetria={studio.telemetriaBiblioteca} slug={slug} estado={s.estado} firma={s.firma} key={slug} />;
}
